"use client";

import { Check, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useCopyToClipboard } from "@/hooks/use-copy-to-clipboard";
import { cn } from "@/lib/utils";

interface CopyButtonProps {
  value: string;
  label: string;
  className?: string;
  stopPropagation?: boolean;
}

export function CopyButton({ value, label, className, stopPropagation = true }: CopyButtonProps) {
  const { copy, copiedKey } = useCopyToClipboard();
  const isCopied = copiedKey === label;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className={cn("size-6 shrink-0", className)}
          aria-label={`Copy ${label}`}
          onClick={(event) => {
            if (stopPropagation) event.stopPropagation();
            void copy(value, label);
          }}
        >
          {isCopied ? <Check className="size-3.5 text-success" aria-hidden="true" /> : <Copy className="size-3.5" aria-hidden="true" />}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{isCopied ? "Copied" : `Copy ${label}`}</TooltipContent>
    </Tooltip>
  );
}
